<template>
    <div :id="id" class="modal fade" tabindex="-1" role="dialog" :aria-labelledby="id + 'label'" aria-hidden="true">
        <div
            :class="{
                'modal-lg': size === 'large',
                'modal-xl': size === 'xl',
                'modal-dialog-centered': centered,
            }"
            class="modal-dialog"
            role="document"
        >
            <div class="modal-content">
                <!-- Modal Header -->
                <div class="modal-header" v-if="$slots.title">
                    <h5 class="modal-title" :id="id + 'label'">
                        <slot name="title"></slot>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span class="icon icon-glyphicons-basic-menu-close align-middle" style="font-size: 20px"></span>
                    </button>
                </div>

                <!-- Modal Body -->
                <div class="modal-body">
                    <slot></slot>
                    <div v-show="loading" class="modal-loader-container center-over w-100 h-100">
                        <div class="modal-loader center-over">
                            <div class="custom-spinner" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Modal Footer -->
                <div class="modal-footer" v-if="$slots.footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BaseModal",
    props: {
        // The id of the element (needed for bootstrap js methods).
        id: {
            type: String,
            required: false,
            default() {
                return String(this._uid)
            },
        },
        // Controls the size of the modal.
        size: {
            type: String,
            default: null,
        },
        // Controls the appearance of a loading spinner.
        loading: {
            type: Boolean,
            default: false,
        },
        // If true, the modal is vertically centered.
        centered: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        hide() {
            $(`#${this.id}`).modal("hide")
        },
        show() {
            $(`#${this.id}`).modal("show")
        },
    },
    mounted() {
        let vm = this
        // Emit an event to let the parent know that the modal has been closed.
        $(`#${this.id}`).on("hidden.bs.modal", function (event) {
            vm.$emit("closed")
        })
    },
    beforeDestroy() {
        // Remove event listeners on the modal.
        $(`#${this.id}`).off()
    },
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

.modal-loader-container {
    text-align: center;
    background-color: #ffffff7d;
    z-index: 1080;
}

.modal-loader {
    display: inline-block;
}

.center-over {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.modal-body {
    min-height: 60px;
}

.modal-title {
    font-size: 1.2rem;
}
</style>